var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-pdf-viewer"},[_c('div',{ref:"pdfContainer",staticClass:"app-pdf-viewer__container"})])}
var staticRenderFns = []

export { render, staticRenderFns }